<template>
  <div class="pocket-investment-success">
    <img :src="require('icons/icon_calendar.svg')">
    <p class="mb-4">
      Your recurring Pocket investment of {{ settings.amount | money }} has been
      successfully scheduled.
    </p>


    <div class="mb-4">
      If you have any questions, please contact us at
      <a href="mailto:support@peerstreet.com">support@peerstreet.com</a>
      or 844-733-7787.
    </div>

    <div class="form-buttons">
      <button class="btn-primary-cta btn-block"
              @click="closeModal">
        Exit
      </button>
    </div>
  </div>
</template>

<script>
import RecurringStore from "./store";
import ModalStore from "../store";

export default {
  data() {
    return {
      storeData: RecurringStore.data,
    };
  },

  computed: {
    settings() {
      return this.storeData.settings;
    },
  },

  methods: {
    closeModal() {
      ModalStore.closeModal();
    },
  },
};
</script>
